import React from 'react'

function Profile_Activity_commision() {
            const customer = JSON.parse(localStorage.getItem("customer"));
    console.log("customer", customer);
    return (
        <div className='Profile_Activity_commision'>
            <div style={{ display: "flex", justifyContent: "space-between", maxWidth: "900px", margin: "auto" }}>
                <span style={{ fontWeight: "700", color: "green" }}>Approved Commission : </span>
                <span style={{ fontWeight: "700", color: "green" }}>{customer?.activity_commission || 0}%</span>
            </div>
        </div>
    )
}

export default Profile_Activity_commision